export enum MultiStepType {
  PRIMARY = "primary",
  SUCCESS = "success",
  DANGER = "danger",
  DARK = "dark"
}

export enum StepStatus {
  PENDING = "pending",
  ACTIVE = "active",
  FULFILLED = "fulfilled"
}

export enum TextPlacement {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical"
}

export enum Size {
  REGULAR = "regular",
  COMPACT = "compact"
}
